(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2492],{

/***/ 3214:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(3328);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b": function() { return /* reexport */ AnimatePage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 165 modules
var motion = __webpack_require__(7592);
;// CONCATENATED MODULE: ./src/components/atoms/AnimatePage/AnimatePage.tsx


var AnimatePage = function(param) {
    var children = param.children;
    var variants = {
        hidden: {
            opacity: 0,
            x: 0,
            y: 100
        },
        enter: {
            opacity: 1,
            x: 0,
            y: 0
        },
        exit: {
            opacity: 0,
            x: 0,
            y: -100
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        initial: "hidden",
        animate: "enter",
        exit: "exit",
        variants: variants,
        children: children
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/AnimatePage/index.ts



/***/ }),

/***/ 4860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* reexport */ Container; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/atoms/Container/Container.tsx

var Container = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mx-auto w-full px-4 lg:mx-20 md:max-w-5xl",
        children: children
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/Container/index.ts



/***/ }),

/***/ 8057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f": function() { return /* reexport */ SeoHead; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/components/atoms/SeoHead/SeoHead.tsx


var SeoHead = function(param1) {
    var title = param1.title, description = param1.description, _author = param1.author, author = _author === void 0 ? 'Jacob Herper' : _author, keywords = param1.keywords, _image = param1.image, image = _image === void 0 ? 'https://res.cloudinary.com/jacobherper/image/upload/v1641565970/website-dark-light.png' : _image, meta = param1.meta;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "author",
                content: author
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:url",
                content: "https://jacobherper.com/"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:creator",
                content: author
            }),
            meta && meta.length > 0 && meta.map(function(param) {
                var name = param.name, content = param.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    name: name,
                    content: content
                }, name);
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:image",
                content: image
            }),
            image && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: image
            }),
            keywords && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "keywords",
                content: keywords.join(', ')
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: "{\"@context\":\"http://schema.org\",\"@type\":\"WebSite\",\"name\":\"JacobHerper.com\",\"alternateName\":\"Jacob Herper\",\"url\":\"https://jacobherper.com/\",\"description\":\"Front-End Software Engineer with a focus on React.js and TypeScript. I have more than 10 years experience working in software engineering.\",\"image\":\"".concat(image, "\"}")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: "{\"@context\":\"http://schema.org\",\"@type\":\"Person\",\"image\":\"https://res.cloudinary.com/jacobherper/image/upload/v1587315576/jacob_herper.jpg\",\"name\":\"Jacob Herper\",\"alternateName\":\"JakeHerp\",\"url\":\"https://herper.io/\",\"jobTitle\":[\"Senior Software Engineer\",\"Frontend Engineer\", \"Front-End Developer\", \"Web Developer\"],\"hasOccupation\":{\"@type\":\"Occupation\",\"name\":\"Senior Software Engineer\",\"occupationLocation\":{\"@type\":\"City\",\"name\":\"London\"},\"estimatedSalary\":[{\"@type\":\"MonetaryAmountDistribution\",\"name\":\"base\",\"currency\":\"GBP\",\"duration\":\"P1H\",\"percentile10\":\"74\",\"percentile25\":\"80\",\"median\":\"90\",\"percentile75\":\"100\",\"percentile90\":\"106\"}],\"description\":\"Develops web applications and websites using JavaScript, React and HTML5.\",\"skills\":\"HTML5, CSS, JavaScript, React, PHP, Sass, Less, Node.js, Express.js, Vue.js, Gatsby, Next.js, JavaScript Frameworks, Git, Github, NPM, SEO, CMS, WordPress, Joomla, Drupal, E-Commerce\",\"alternateName\":[\"Frontend Developer\",\"Full Stack Developer\",\"Frontend Engineer\"],\"responsibilities\":[\"App Development\",\"Web Design\",\"Website Development\",\"JavaScript Development\",\"WordPress Development\",\"CMS Development\",\"Frontend Development\",\"Full Stack Development\",\"Online Marketing\",\"SEO Services\",\"Web Developer\",\"Website Maintenance\"]},\"sameAs\":[\"http://linkedin.com/in/jacobherper\",\"http://twitter.com/jakeherp\",\"https://github.com/jakeherp\",\"https://www.facebook.com/jakeherp\",\"https://instagram.com/jakeherp\"],\"brand\":[{\"@type\":\"Brand\",\"name\":\"Software Engineer\",\"alternateName\":\"Front-End Engineer\"},{\"@type\":\"Brand\",\"name\":\"JakeHerp\",\"alternateName\":\"Jacob Herper\"}],\"memberOf\":[{\"@type\":\"Organization\",\"url\":\"https://creativ.agency/\",\"name\":\"Creativ Agency Ltd\",\"alternateName\":\"Creativ Advertising Agency\"},{\"@type\":\"Organization\",\"url\":\"https://www.dennis.co.uk/\",\"name\":\"Dennis Digital\",\"alternateName\":\"Dennis\"}],\"homeLocation\":{\"@type\":\"City\",\"name\":\"London\"},\"owns\":{\"@type\":\"Organization\",\"url\":\"https://creativ.agency/\",\"name\":\"Creativ Agency Ltd\",\"alternateName\":\"Creativ Advertising Agency\",\"sameAs\":\"https://www.linkedin.com/company/creativ.agency\"},\"alumniOf\":{\"@type\":\"Organization\",\"url\":\"https://www.thespecialistworks.com/\",\"name\":\"The Specialist Works\"},\"nationality\":{\"@type\":\"Country\",\"name\":\"Germany\"},\"birthDate\":\"1990-11-06\",\"birthPlace\":{\"@type\":\"Place\",\"address\":{\"@type\":\"PostalAddress\",\"addressLocality\":\"Oelsnitz\",\"postalCode\":\"08606\",\"addressCountry\":\"Germany\"}},\"parent\":[{\"name\":\"Norbert Herper\",\"jobTitle\":\"Chef\",\"birthDate\":\"1967-08-22\"},{\"name\":\"Anne-Kristin Herper\",\"birthDate\":\"1968-02-26\"}],\"spouse\":{\"name\":\"Cinthia Cid Paz\",\"birthDate\":\"1990-09-19\",\"nationality\":{\"@type\":\"Country\",\"name\":\"Mexico\"},\"birthPlace\":{\"@type\":\"Place\",\"address\":{\"@type\":\"PostalAddress\",\"addressLocality\":\"Toluca\",\"addressCountry\":\"Mexico\"}}}}"
                }
            })
        ]
    });
};


;// CONCATENATED MODULE: ./src/components/atoms/SeoHead/index.ts



/***/ }),

/***/ 3328:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var date_fns_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8582);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2017);
/* harmony import */ var Atoms_AnimatePage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1660);
/* harmony import */ var Atoms_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4860);
/* harmony import */ var Atoms_SeoHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8057);
/* harmony import */ var utils_mdxComponents__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8817);







var PostPage = function(param) {
    var data = param.data;
    var numOfWords = data.blogs[0].content.split(' ').length;
    var readTime = Math.ceil(numOfWords / 250);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Atoms_AnimatePage__WEBPACK_IMPORTED_MODULE_1__/* .AnimatePage */ .b, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Atoms_SeoHead__WEBPACK_IMPORTED_MODULE_3__/* .SeoHead */ .f, {
                    title: "".concat(data.blogs[0].title, " - Jacob Herper's Blog"),
                    description: data.blogs[0].seoDescription
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Atoms_Container__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            className: "headline text-3xl md:text-4xl lg:text-5xl mt-8",
                            children: data.blogs[0].title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                            className: "my-8 flex justify-between text-sm md:text-md",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("em", {
                                    children: [
                                        "~",
                                        readTime,
                                        " minute read"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                    children: [
                                        "Written on",
                                        ' ',
                                        (0,date_fns_format__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new Date(data.blogs[0].publishedDate), 'do MMM yyyy')
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_6__/* .ReactMarkdown */ .D, {
                            components: utils_mdxComponents__WEBPACK_IMPORTED_MODULE_4__/* .mdxComponents */ .d,
                            children: data.blogs[0].content
                        })
                    ]
                })
            ]
        })
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (PostPage);


/***/ }),

/***/ 8817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ mdxComponents; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react_syntax_highlighter_dist_cjs_styles_hljs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6671);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4237);




var mdxComponents = {
    h2: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: "headline text-3xl mt-8",
            children: children
        });
    },
    h3: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
            className: "headline text-2xl mt-8",
            children: children
        });
    },
    a: function(param) {
        var children = param.children, href = param.href;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            href: href,
            target: "_blank",
            className: "underlined relative",
            rel: "noopener noreferrer",
            children: children
        });
    },
    ul: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            className: "list-disc ml-4 mt-4",
            children: children
        });
    },
    li: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
            className: "mt-1",
            children: children
        });
    },
    p: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: "mt-4 mb-4 text-lg leading-7",
            children: children
        });
    },
    code: function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_syntax_highlighter__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            language: "typescript",
            style: react_syntax_highlighter_dist_cjs_styles_hljs__WEBPACK_IMPORTED_MODULE_3__/* .dracula */ .cL,
            className: "text-sm rounded-md p-4 border border-grey-300 dark:border-grey-700 shadow-lg shadow-grey-500 dark:shadow-grey-800",
            children: children
        });
    },
    img: function(param) {
        var alt = param.alt, src = param.src;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative w-full aspect-video drop-shadow-xl",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_image__WEBPACK_IMPORTED_MODULE_1__["default"], {
                src: src,
                alt: alt,
                layout: "fill",
                objectFit: "cover",
                className: "mt-4 mb-4"
            })
        });
    }
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8582,1512,9774,2888,179], function() { return __webpack_exec__(3214); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);